// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3SJwm","colMaxWidth":"Table_colMaxWidth__ww3fI"};